import React, { useState, useEffect, memo } from 'react';
import './tagManagement.css';

import { callAPI } from '../utils';
import Tag from "../ui/tags";
import Table from "../table/table";
import TableSelector from './tableSelector';
import TagModal from './tagModal';

const DataViewer = () => {
  const [activeTable, setActiveTable] = useState(null);
  const [tableData, setTableData] = useState({});
  const [currentData, setCurrentData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchTableData();
  }, []);

  useEffect(() => {
    if (activeTable && tableData[activeTable]) {
      setCurrentData(getFullTableData(activeTable));
      setColumns(getColumns(activeTable));
    }
  }, [activeTable, tableData]);

  const getColumns = (table) => {
    const headers = [
      { header: "ID", accessor: "value" },
      { header: "Tag", accessor: "label" }
    ];
  
    if (table && tableData[table] && tableData[table][0]) {
      const data = tableData[table][0];
     
      Object.keys(data).forEach((key) => {
        if (key == "value" || key == "label") return;
        headers.push({ header: key, accessor: key });
      });
    } else {
      console.error("Error: 'data' field is missing or table data is not available.");
    }
  
    return headers;
  };

  const fetchTableData = async () => {
    try {
      callAPI({
        request: "database/getAllStaticTables",
        method: "get",
        onSuccess: (response) => {
          setTableData(response.data);
        },
        onError: (err) => console.error("Error fetching tables:", err),
      });
    } catch (err) {
      console.error("Error fetching table data:", err);
    }
  };

  const handleRowClick = (row) => {
    setSelectedTag(row);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedTag(null);
  };

  const handleTagEdit = () => {
    console.log("Editing tag:", selectedTag);
  };

  const handleTagSave = () => {
    setTags(tags.map(tag => (tag.id === selectedTag.id ? selectedTag : tag)));
    handleModalClose();
  };

  const handleTagDelete = () => {
    setTags(tags.filter(tag => tag.id !== selectedTag.id));
    handleModalClose();
  };

  const handleTagInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedTag(prev => ({ ...prev, [name]: value }));
  };

  const handleTagColorChange = (e) => {
    setSelectedTag(prev => ({ ...prev, colour: e.target.value }));
  };

  const getFullTableData = (table) => {
    if (table && tableData[table]) {
      let row = tableData[table];
  
      row.forEach((item) => {
        if (item["data"]) {
          Object.keys(item["data"]).forEach((field) => {
            item[field] = item["data"][field];
          });
  
          delete item["data"];
        }
      });
      return row;
    }

    return [{data:"none"}];
  };

  return (
    <div className="data-viewer">
      <div className="tag-table-container">
        <TableSelector tables={Object.keys(tableData)} setActiveTable={setActiveTable} />
        <div className="table-content">
          <h2>Active Table: {activeTable}</h2>
          <br />
          <Table 
            data={currentData} 
            columns={columns} 
            onRowClick={handleRowClick} 
          />
        </div>
      </div>

      {isModalOpen && selectedTag && (
        <TagModal
          tag={selectedTag}
          isEditing={true}
          onClose={handleModalClose}
          onEdit={handleTagEdit}
          onDelete={handleTagDelete}
          onSave={handleTagSave}
          onInputChange={handleTagInputChange}
          onColorChange={handleTagColorChange}
        />
      )}
    </div>
  );
};

export default memo(DataViewer);
